export default {
  EANBW_BIG_WIN_IDLE: 'big_win_idle',
  EANBW_MEGA_WIN_IDLE: 'mega_win_idle',
  EANBW_EPIC_WIN_IDLE: 'epic_win_idle',
  EANBW_BIG_WIN_START: 'big_win_start',
  EANBW_MEGA_WIN_START: 'mega_win_start',
  EANBW_EPIC_WIN_START: 'epic_win_start',

};
